import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import {fetchCurrentUserDetailRequest, fetchLoginRequest, pcBangUserLogout} from '../../actions/user.actions';
import moment from 'moment';

import Captcha from './Captcha';
import './Login.scss';

const stateToProps = state => {
  return {
    user: state.user,
  };
};

export class Login extends Component {
  componentDidMount() {
    if (Object.keys(this.props.user).length === 0 && sessionStorage.getItem('token')) {
      this.props.dispatch(fetchCurrentUserDetailRequest());
    }
  }

  isValidUserName(userName) {
    return /^[a-z0-9_]+$/g.test(userName);
  }

  _prepareLogin = e => {
    e.preventDefault();
    if (!this.isValidUserName(this.userNameInput.value)) {
      alert('아이디는 소문자 및 숫자 조합으로 입력해주세요.');
      return;
    }

    this.captchaRef.execute();
  };

  _login(captchaToken) {
    if (captchaToken === undefined || captchaToken === '') {
      window.alert('Captcha token에 문제가 있습니다. 다시 진행해 주세요.');
      return;
    }
    this.props.dispatch(
      fetchLoginRequest(
        this.userNameInput.value,
        this.passwordInput.value,
        captchaToken,
        this.captchaRef,
        this.loginForm
      )
    );
  }

  logout = () => {
    this.props.dispatch(pcBangUserLogout());
  };

  setOnClassIfNeeded = e => {
    let classNames = e.target.className.split(' ');
    if (!e.target.value) {
      e.target.className = classNames.filter(e => e !== 'on');
      return;
    }

    if (!classNames.includes('on')) {
      classNames.push('on');
    }

    e.target.className = classNames.join(' ');
  };

  isPasswordChangeNeeded() {
    let {user} = this.props;

    if ((user.pcBangStatus && user.pcBangStatus === 'WITHDRAWN') || user.pcBangStatus === 'CLOSED') {
      return false;
    }

    let lastPasswordUpdated = user.passwordUpdated ? moment.utc(user.passwordUpdated) : moment.utc(user.created);

    if (!location.href.includes('/member-service/password-change') && moment().diff(lastPasswordUpdated, 'days') > 90) {
      return true;
    }

    return false;
  }

  render() {
    const {user} = this.props;
    if (!user || !user.username || !sessionStorage.getItem('token')) {
      return this.renderLoginForm();
    }

    if (this.isPasswordChangeNeeded()) {
      alert('회원정보 수정 이후 90일이 초과되었습니다.\n보안을 위해 고객님의 비밀번호를 변경해 주시기 바랍니다.');
      return <Redirect to="/member-service/password-change" />;
    }

    return this.renderUserInfo(user);
  }

  renderLoginForm = () => (
    <form ref={node => (this.loginForm = node)} autoComplete="off">
      <ul className="login-form">
        <li className="input-placeholder">
          <input
            tabIndex="1"
            type="text"
            name="userName"
            maxLength="16"
            autoComplete="off"
            style={{imeMode: 'disabled'}}
            placeholder=" "
            className="login-input"
            ref={input => (this.userNameInput = input)}
            onChange={this.setOnClassIfNeeded}
          />
          <label>아이디</label>
          <Link to="/member-service/id-search">아이디 찾기</Link>
        </li>
        <li className="input-placeholder">
          <input
            tabIndex="2"
            type="password"
            name="password"
            maxLength="16"
            autoComplete="off"
            style={{imeMode: 'disabled'}}
            placeholder=" "
            className="login-input"
            ref={input => (this.passwordInput = input)}
            onChange={this.setOnClassIfNeeded}
          />
          <label>비밀번호</label>
          <Link to="/member-service/password-reset">비밀번호 찾기</Link>
        </li>
        <li>
          <input
            tabIndex="3"
            type="submit"
            className="btn-blue"
            data-qa="loginButton"
            value="로그인"
            onClick={this._prepareLogin}
          />
          <Link to="/member-service/join">회원가입</Link>
        </li>
      </ul>
      <Captcha
        ref={captchaRef => (this.captchaRef = captchaRef)}
        onVerify={captchaToken => this._login(captchaToken)}
      />
    </form>
  );

  renderUserInfo = user => (
    <ul className="user-info">
      <li>
        <Link to="/my-pc-bang/management/user-info-modification">{user.username}</Link>
      </li>
      <li className="pcbang-info">
        <div className="pcbang-info__ip">{user.ipAddress}</div>
        <Link to="/my-pc-bang/management/ip-management">
          {user.pcBangName}
          <img src="/image/layout/setting.svg" alt="설정" />
        </Link>
      </li>
      <li>
        <input type="button" className="btn-blue" value="로그아웃" onClick={this.logout} data-qa="logoutButton" />
      </li>
    </ul>
  );
}

export default connect(stateToProps)(Login);
